import { MessageProvider } from '@messageformat/react';
import { LocaleProvider } from '@op/opds.opux';
import { useContext, useEffect } from 'react';
import { ChangeStateContext, StateContext } from './State';
import { ModelContext } from './ModelContext';
import _ from 'lodash';
import * as authComponentsMessagesFi from '@op/auth-components/messages-fi';
import fullpageloginMessagesFi from './messages/messages_fi.properties';
import * as authComponentsMessagesSv from '@op/auth-components/messages-sv';
import fullpageloginMessagesSv from './messages/messages_sv.properties';
import * as authComponentsMessagesEn from '@op/auth-components/messages-en';
import fullpageloginMessagesEn from './messages/messages_en.properties';
import PropTypes from 'prop-types';

export function AppMessageProvider({ children }) {
    const state = useContext(StateContext);
    const changeState = useContext(ChangeStateContext);
    const { model } = useContext(ModelContext);

    // Sets messages to state for current locale.
    // NOTE: For auth-component's messages lazy loading to actually work, it would need
    // some fixes to babel/webpack build configuration.
    useEffect(() => {
        const emptyLoginTitle = { login: { title: { authenticate: '' } } };
        const finnish = _.merge({}, authComponentsMessagesFi, emptyLoginTitle, { fp: fullpageloginMessagesFi }, model.messages.fi);
        const swedish = _.merge({}, authComponentsMessagesSv, emptyLoginTitle, { fp: fullpageloginMessagesSv }, model.messages.sv);
        const english = _.merge({}, authComponentsMessagesEn, emptyLoginTitle, { fp: fullpageloginMessagesEn }, model.messages.en);

        document.title = model.messages[state.lang]['fp']['serviceName'];
        switch (state.lang) {
            case 'fi':
                changeState({ messages: finnish });
                break;
            case 'sv':
                changeState({ messages: swedish });
                break;
            case 'en':
                changeState({ messages: english });
                break;
            default:
                changeState({ messages: finnish });
                break;
        }
    }, [model.messages, state.lang, changeState]);

    return (
        <LocaleProvider locale={state.lang}>
            <MessageProvider locale={state.lang} messages={state.messages}>
                {children}
            </MessageProvider>
        </LocaleProvider>
    );
}
AppMessageProvider.propTypes = {
    children: PropTypes.object,
};
